import { render, staticRenderFns } from "./almacen-entradas.vue?vue&type=template&id=fdee4a9c&"
import script from "./almacen-entradas.vue?vue&type=script&lang=js&"
export * from "./almacen-entradas.vue?vue&type=script&lang=js&"
import style0 from "./almacen-entradas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports